import React, { useEffect } from 'react';
import { View } from 'react-native';
import Animated, { withTiming, interpolate, useSharedValue, useAnimatedStyle, } from 'react-native-reanimated';
import Text from 'design-system/Text';
import { CardView } from 'design-system';
import useStyles from 'hooks/useStyles';
import createStyleSheets from 'utils/createStyleSheets';
import IconCheck from 'design-system/icons/IconCheck';
const ProgressItem = ({ title }) => {
    const sharedValue = useSharedValue(0);
    const styles = useStyles(styleSet);
    useEffect(() => {
        sharedValue.value = withTiming(1, {
            duration: 500,
        });
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    const animatedStyles = useAnimatedStyle(() => ({
        opacity: interpolate(sharedValue.value, [0, 1], [0, 1]),
        transform: [
            {
                translateY: interpolate(sharedValue.value, [0, 1], [40, 0]),
            },
        ],
    }), []);
    return (<Animated.View style={animatedStyles}>
      <CardView style={styles.container} withPadding noMarginBottom>
        <View style={styles.textContainer}>
          <Text Text-16>{title}</Text>
        </View>
        <IconCheck thick/>
      </CardView>
    </Animated.View>);
};
export default ProgressItem;
const styleSet = createStyleSheets((colors) => ({
    container: {
        alignItems: 'center',
        flexDirection: 'row',
        backgroundColor: colors.cards.onDark,
    },
    textContainer: {
        flex: 1,
    },
}));
